import React, { useEffect, useState } from 'react';
import { Table, createStyles, Flex, Button, Modal, useMantineTheme, Image, Box, Portal, Overlay, Loader } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import PartnerForm from '../forms/PartnerForm';
import { getBanners, deleteBanner } from '../../services/api.service';
import DeleteButton from '../buttons/DeleteButton';
import DataTable from '../table/DataTable';
import TableHeader from '../table/TableHeader';
import CustomModal from '../modal/CustomModal';
import BannerInAppForm from '../forms/BannerInAppForm';
import { useEntityManager } from '../../hooks/useEntityManager';
import dayjs from 'dayjs';

// Custom styles
const useStyles = createStyles((theme) => ({
    container: {
        padding: theme.spacing.md,
        height: '100%',
    },
    imagePreview: {
        padding: 3,
        border: `1px solid ${theme.colorScheme === 'dark' ? theme.white : theme.black}`,
        borderRadius: theme.radius.sm,
        backgroundColor: theme.colorScheme === 'dark' ? theme.white : theme.black,
    }
}));

const BannerInApp = () => {

    const [opened, { open, close }] = useDisclosure(false);
    const theme = useMantineTheme();
    const { classes } = useStyles();
    const {
        isLoading,
        search,
        handleSearchChange,
        filteredEntities: filteredBanner,
        isEdit,
        setIsEdit,
        editItem: bannerEdit,
        toggleEdit: toggleBannerEdit,
        handleCloseModal,
        openDeleteModal,
        isDeleteLoading,
    } = useEntityManager({
        fetchEntities: getBanners,
        deleteEntity: deleteBanner,
        entityName: 'Banner',
        article: 'eliminado',
        filterKey: 'title',
    });

    const columns = [
        { label: 'ID', key: 'id' },
        { label: 'Imagen', key: 'image' },
        { label: 'Título', key: 'title' },
        { label: 'Descripción', key: 'description' },
        { label: 'Fecha de Inicio', key: 'startDate' },
        { label: 'Fecha de Finalización', key: 'endDate' },
        { label: 'Cooldown', key: 'cooldown' },
        { label: '', key: 'actions' },
    ];

    const renderRow = (item) => (
        <tr
            key={item.id}
            onClick={(e) => {
                toggleBannerEdit(e, item);
                open();
            }}
            style={{ cursor: 'pointer' }}
        >
            <td>{item.id}</td>
            <td>
                <Image
                    src={item.image}
                    alt="Logo"
                    radius={theme.radius.sm}
                    maw={100}
                    className={classes.imagePreview}
                />
            </td>
            <td>{item.title}</td>
            <td>{item.description}</td>
            <td>{item.startDate ? dayjs(new Date(item.startDate)).format('DD/MM/YYYY') : 'N/A'}</td>
            <td>{item.endDate ? dayjs(new Date(item.endDate)).format('DD/MM/YYYY') : 'N/A'}</td>
            <td>{item.cooldown}</td>
            <td>
                <DeleteButton
                    onClick={(e) => {
                        e.stopPropagation();
                        openDeleteModal(item.id);
                    }}
                />
            </td>
        </tr>
    );

    return (
        <>
            {/* Modal */}
            <CustomModal opened={opened}>
                <BannerInAppForm
                    closeModal={() => {
                        close();
                        handleCloseModal();
                    }}
                    isEdit={isEdit}
                    banner={bannerEdit}
                />
            </CustomModal>
            {/* Delete Loader */}
            {isDeleteLoading ?
                <Portal>
                    <Overlay
                        sx={{ zIndex: 999 }}
                        center
                        blur={15}
                    >
                        <Loader size={100} />
                    </Overlay>
                </Portal>
                : null}
            <Box className="mainContainer">
                {/* Content */}
                <Flex
                    direction="column"
                    justify="space-between"
                    className={classes.container}
                >
                    <TableHeader
                        title="Banners In-App"
                        buttonLabel="Nuevo Banner"
                        onButtonClick={
                            () => {
                                open();
                                setIsEdit(false);
                            }
                        }
                        searchValue={search}
                        onSearchChange={handleSearchChange}
                        searchPlaceholder="Buscar banners"
                    />
                    <Flex direction="column">
                        {/* Table */}
                        <DataTable
                            data={filteredBanner}
                            columns={columns}
                            renderRow={renderRow}
                            loading={isLoading}
                        />
                    </Flex>
                </Flex>
            </Box>
        </>
    );

}

export default BannerInApp;
